import axios from 'axios'
import { toast } from 'react-toastify'
import store from '../../global/config/store';
import { hideLoader, showLoader } from '../../global/config/Reducer/loaderSlice';
import { logout } from '../../global/config/Reducer/authSlice';

let toastShown = false
let apiCount = 0;

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
})

instance.interceptors.request.use(
  (config) => {
    apiCount++;
    store.dispatch(showLoader());
    // const token = localStorage.getItem('token');
    const token = store.getState().auth.token;
    localStorage.setItem('token', token || '');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    apiCount--;
    if (apiCount === 0) store.dispatch(hideLoader());
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    apiCount--;
    if (apiCount === 0) store.dispatch(hideLoader());
    return response;
  },
  error => {
    apiCount--;
    if (apiCount === 0) store.dispatch(hideLoader());
    console.log('API error', error)
    if (error?.status === 403) {
      handleLogout()
    }
    return Promise.reject(error)
  }
)

const handleLogout = () => {
  if (!toastShown) {
    toast.info('Your session has expired. Please log in again to continue.', {
      autoClose: 5000
    })
    toastShown = true
    store.dispatch(logout());
  }
}

export default instance
